/**
 * Absolute, with no trailing slash. Production's VITE_API_BASE_URL is the
 * relative `/api`, and the nauth SDK builds its social sign-in URL with
 * `new URL()`, which rejects a bare path — so it is resolved against the page
 * origin once, here.
 */
export const API_BASE_URL: string = new URL(
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001',
  window.location.origin,
).href.replace(/\/$/, '');
